import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { FormBuilder } from "@angular/forms"
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material"
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { Stringable, StringableValues } from "../../../../../common/stringable.decorator"
import { JSONRpcResponse } from "../../../../../Interfaces/JSONRpcResponse"
import { DialogService, VisiteService } from "../../../../../services"
const KEY = 'visite-listing'
@Component({
  selector: 'atyl-visite-listing',
  templateUrl: './visite-listing.component.html',
  styleUrls: ['./visite-listing.component.scss']
})

@Stringable({
  path: "views/partials/content/listing/visite-listing",
  key: KEY,
})
export class VisiteListing extends BaseDialogComponent implements OnInit {

  listSubscription: any[] = [];
  selectedVisites: any[] = [];
  listVisites: any[] = [];
  @StringableValues(KEY)
  strings: any
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VisiteListing>,
    private visiteService: VisiteService,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    dialogService: DialogService
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    this.listSubscription.push(this.visiteService.getVisitesByDossier(this.data.dossier.ID).subscribe((res: JSONRpcResponse) => {
      this.listVisites = res.result
    }))
  }
  ngOnDestroy() {
    this.listSubscription.forEach(sub => sub.unsubscribe())
  }
  closeDialog(event: any) {
    this.dialogRef.close(event)
  }
  selectOrRemoveVisite(suivi: any) {
    if (this.selectedVisites.indexOf(suivi) > -1) {
      this.selectedVisites.splice(this.selectedVisites.indexOf(suivi), 1)
    } else {
      this.selectedVisites.push(suivi)
    }
  }

  submitSelectedVisitesList(event: any) {
    let demandeFormulaire = this.data.formulaire.demandeFormulaire
    let webserviceParams = {
      visites: this.idFiy(this.selectedVisites),
      demandeFormulaire: demandeFormulaire.ID,
      options: []
    }
    console.log(webserviceParams, demandeFormulaire)
    this.listSubscription.push(
      this.visiteService.addFormulaireToVisites(webserviceParams.visites, webserviceParams.demandeFormulaire, webserviceParams.options).subscribe((res: JSONRpcResponse) => {
        if (res) {
          this._snackBar.open('visites ajoutés avec succès', 'X', {
            duration: 2000,
            panelClass: 'snackbar-success'
          })
          this.closeDialog(true)
        }
      }, err => {
        this._snackBar.open('Erreur lors de l\'ajout du formulaire', 'X', {
          duration: 2000,
          panelClass: 'snackbar-danger'
        })
      }
      ))
  }

  idFiy(visitesList: any[]) {
    return visitesList.map((visite: any) => visite.ID)
  }

}
